var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9993 2.67188C8.65268 2.67188 2.66602 8.65854 2.66602 16.0052C2.66602 23.3519 8.65268 29.3385 15.9993 29.3385C23.346 29.3385 29.3327 23.3519 29.3327 16.0052C29.3327 8.65854 23.346 2.67188 15.9993 2.67188ZM20.4793 19.0719C20.866 19.4585 20.866 20.0985 20.4793 20.4852C20.2793 20.6852 20.026 20.7785 19.7727 20.7785C19.5193 20.7785 19.266 20.6852 19.066 20.4852L15.9993 17.4185L12.9327 20.4852C12.7327 20.6852 12.4793 20.7785 12.226 20.7785C11.9727 20.7785 11.7193 20.6852 11.5193 20.4852C11.1327 20.0985 11.1327 19.4585 11.5193 19.0719L14.586 16.0052L11.5193 12.9385C11.1327 12.5519 11.1327 11.9119 11.5193 11.5252C11.906 11.1385 12.546 11.1385 12.9327 11.5252L15.9993 14.5919L19.066 11.5252C19.4527 11.1385 20.0927 11.1385 20.4793 11.5252C20.866 11.9119 20.866 12.5519 20.4793 12.9385L17.4127 16.0052L20.4793 19.0719Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.9531f6cd2694d98ebe17f037a770fb92.svg";
export { ForwardRef as ReactComponent };